// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2exDx","savePackageButton":"ClientWallet_savePackageButton__17Fyh"};